<template>
    <div id="moduleAppList">
        <div class="top">
            <el-button size="medium" type="primary" @click="jumpToPage('subjectAddEdit')">新增课程</el-button>
<!--            <el-button size="medium" type="primary" @click="batchDeleteHandler">删除课程</el-button>-->

            <el-select size="medium" @change="getList()" v-model="level" placeholder="请选择学校类型"
                       >
                <el-option label="全部学校类型" :value="'0'"></el-option>
                <el-option :value="1" label="幼儿园"></el-option>
                <el-option :value="2" label="小学"></el-option>
                <el-option :value="3" label="初中"></el-option>
                <el-option :value="4" label="高中"></el-option>
                <el-option :value="7" label="大中专"></el-option>
                <el-option :value="10" label="特殊教育"></el-option>
            </el-select>

            <el-input size="medium" class="search-input search-input--right" placeholder="课程名称"
                      v-model="searchName" @keyup.enter.native="getList">
                <el-button slot="append" icon="el-icon-search" size="medium" @click="getList"></el-button>
            </el-input>
        </div>
        <div>
            <el-table
                :height="windowHeight - 210"
                :data="dataList"
                style="width: 100%" border
                @selection-change="handleSelectionChange"
            >
                <el-table-column
                    type="selection"
                    width="55">
                </el-table-column>
                <el-table-column
                    label="课程编码"
                    prop="code"
                    align="center"
                >
                </el-table-column>
                <el-table-column
                    label="课程图标"
                    align="center" show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        <img class="courseLogo" :src="scope.row.logoUrl || 'https://wxtestpb-10048617.image.myqcloud.com/70dde043-1baf-4c5e-9114-bfd1d41641ee?imageView2/q/100/w/800'" />
                    </template>

                </el-table-column>
                <el-table-column
                    label="课程名称" show-overflow-tooltip
                    align="center"
                >
                    <template slot-scope="scope">
                        <span class="link" @click="jumpToPage('subjectAddEdit', {id: scope.row.id})">
                        {{ scope.row.name }}
                         </span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="课程简称"
                    width="200px"
                    align="center" show-overflow-tooltip
                    prop="otherName"
                >
                </el-table-column>
                <el-table-column
                    label="国标课程"
                    align="center" show-overflow-tooltip
                >
                    <template slot-scope="scope">
                        <span>
                            {{ scope.row.isNS == 1 ? '是' : '否' }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="学科类型" show-overflow-tooltip
                    align="center"
                >
                    <template slot-scope="scope">
                        {{['', '综合学科', '主学科', '校本学科', '校本学科'][scope.row.isMain]}}
                    </template>
                </el-table-column>

                <el-table-column
                    label="所属年段" show-overflow-tooltip
                    align="center"
                >
                    <template slot-scope="scope">
                        {{scope.row.level == 0 ? '未知' : parseToConstants(scope.row.level, 'schoolTypeConstants')}}
                    </template>
                </el-table-column>
                <el-table-column
                    label="考试类型" show-overflow-tooltip
                    align="center"
                >
                    <template slot-scope="scope">
                        {{['未知', '考试', '考查'][scope.row.examType]}}
                    </template>
                </el-table-column>
                <el-table-column width="140"
                                 label="操作"
                                 align="center"
                >
                    <template slot-scope="scope">
                        <el-button type="text" size="small" @click="jumpToPage('subjectAddEdit', {id: scope.row.id})">编辑</el-button>
                        <el-button type="text" size="small" @click="deleteHandler(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-container">
                <el-pagination
                    @size-change="sizeChangeHandler"
                    @current-change="currentChangeHandler"
                    :current-page.sync="pagination.pageNo"
                    :page-sizes="[10 , 20, 30, 50]"
                    :page-size.sync="pagination.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :page-count="pagination.pages"
                    :total="pagination.total"
                >
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import {schoolTypeConstants} from '@/utils/constants';
    import {parseToConstants, isShowByPermission} from '@/utils/utils';

    import windowResize from '@/mixins/windowResize';
    import baseMixin from '@/mixins/baseMixin';
    import {queryCurriculumList, deleteCurriculum} from '@/api/subjectManagement';


    export default {
        name: 'subjectList',
        data() {
            return {
                searchName: '',
                dataList: [],
                multipleSelection: [],
                level: '0',
                schoolTypeConstants,

            }
        },
        filters: {
            timeFormat(time) {
                return time ? time.substring(0, 19) : ''
            }
        },
        created() {
            this.queryCurriculumListFunc()
        },
        beforeRouteEnter(to, from, next) {
            next(vm => {
                vm.queryCurriculumListFunc()
            });
        },
        mixins: [windowResize, baseMixin],
        methods: {
            isShowByPermission,
            parseToConstants,
            getList() {
                this.pagination.pageNo = 1;
                setTimeout(() => {
                    this.queryCurriculumListFunc();
                }, 100);
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            sizeChangeHandler() {
                this.queryCurriculumListFunc();
            },
            currentChangeHandler() {
                this.queryCurriculumListFunc();
            },
            batchDeleteHandler() {
                if (this.multipleSelection.length === 0) {
                    this.$message.error('请选择要删除的课程');
                } else {
                    this.deleteHandler(this.multipleSelection.map(({id}) => id).join(','));
                }
            },
            deleteHandler(delIds) {
                this.$confirm('确认要删除吗？', '删除', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    lockScroll: false
                }).then(() => {
                    deleteCurriculum({
                        delIds
                    })
                        .then(() => {
                            this.queryCurriculumListFunc();
                        })
                });
            },
            queryCurriculumListFunc() {
                queryCurriculumList({
                    level: this.level,
                    searchName: this.searchName,
                    pageNo: this.pagination.pageNo,
                    pageSize: this.pagination.pageSize
                })
                    .then(data => {
                        this.dataList = data.curriculumList;
                        this.pagination.total = data.pagination.total;
                    })
            }
        }
    }
</script>
<style>
    .courseLogo {
        width: 25px;
        height: 25px;
    }
</style>
<style lang="scss" scoped>
    #moduleAppList {
        padding: 12px;

        .pagination-container {
            margin-top: 10px;
        }

        .top {
            padding-bottom: 10px;
            overflow: hidden;

        }

        a, .link {
            color: #409EFF;
            cursor: pointer;
        }

        .state-container {
            margin: 15px 0;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/systemData/subjectManagement/subjectList.vue